export default "__VITE_ASSET__425bd3a8__"